import { dmnStorage } from "../dmnStorage";

const storageKey = "floorPlan";

export type FloorPlanConfigDataStorageType = {
  displayNonTableItems: boolean;
  displayTableNames: boolean;
  zoomLevel: number;
};

export const floorPlanConfigStorageDefault: FloorPlanConfigDataStorageType = {
  displayNonTableItems: true,
  displayTableNames: true,
  zoomLevel: 0
};

export const addFloorPlanConfigStorage = async (
  data: FloorPlanConfigDataStorageType
) => {
  return await dmnStorage.add(storageKey, data);
};

export const getFloorPlanConfigStorage =
  async (): Promise<FloorPlanConfigDataStorageType> => {
    const response: FloorPlanConfigDataStorageType | undefined =
      await dmnStorage.get(storageKey);

    return response || floorPlanConfigStorageDefault;
  };
